export const common = [
  { label: "Home", url: "/" },
  { label: "Auction", url: "/nft-auction" },
  { label: "NFT Marketplace", url: "/marketplace" },
  { label: "Vesting & Claims", url: "/claims" },
  { label: "Raise", url: "/raise" },
  { label: "Signals Service", url: "/forexs" },
];
export const publicNav = [
  { label: "Home", url: "/" },
  { label: "Auction", url: "/nft-auction" },
  {
    label: "NFT Marketplace",
    url: "/marketplace",
  },
  { label: "NFT1", url: "/NFTone" },
  { label: "Signals Service", url: "/forexs" },
  { label: "on boarding", url: "/on-boarding" },
  { label: "raise", url: "/raise" },
  { label: "NFT details", url: "/nft-details" },
  { label: "New NFT details", url: "/nft-small" },
  { label: "claims", url: "/claims" },
  { label: "reward", url: "/reward" },
  { label: "explore", url: "/explore" },
  { label: "profile", url: "/my-profile" },
  { label: "subscription", url: "/subscription" },
  { label: "portal", url: "/portal" }
].sort((a, b) => a.label.localeCompare(b.label));

export const privateNav = [
  { label: "Home", url: "/" },
  { label: "Auction", url: "/nft-auction" },
  { label: "NFT Marketplace", url: "/marketplace" },
  { label: "Vesting & Claims", url: "/claims" },
  { label: "Raise", url: "/raise" },
  { label: "Signals Service", url: "/forexs" },
];
